/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Encoding_OptionsInputs */

const en_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoding Options`)
};

const fr_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options d'encodage`)
};

const de_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodierungsoptionen`)
};

const it_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di codifica`)
};

const ru_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры кодирования`)
};

const es_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de codificación`)
};

const zh_cn2_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码选项`)
};

const ja_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンコードオプション`)
};

const hi_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एन्कोडिंग विकल्प`)
};

const pt_pt2_dialogue_list_export_encoding_options = /** @type {(inputs: Dialogue_List_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de codificação`)
};

/**
* | output |
* | --- |
* | "Encoding Options" |
*
* @param {Dialogue_List_Export_Encoding_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_encoding_options = /** @type {((inputs?: Dialogue_List_Export_Encoding_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Encoding_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_encoding_options(inputs)
	if (locale === "de") return de_dialogue_list_export_encoding_options(inputs)
	if (locale === "it") return it_dialogue_list_export_encoding_options(inputs)
	if (locale === "ru") return ru_dialogue_list_export_encoding_options(inputs)
	if (locale === "es") return es_dialogue_list_export_encoding_options(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_encoding_options(inputs)
	if (locale === "ja") return ja_dialogue_list_export_encoding_options(inputs)
	if (locale === "hi") return hi_dialogue_list_export_encoding_options(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_encoding_options(inputs)
	return en_dialogue_list_export_encoding_options(inputs)
});